import { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ArrowUpRight, Copy, Check } from "lucide-react";
import { ACTRA_CONTRACT_ADDRESS, CONTRACT_MESSAGE, CONTRACT_SHORT, EXPLORER_ADDRESS_URL } from "@/config/actra";

export const ContractStatus = () => {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(ACTRA_CONTRACT_ADDRESS);
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
        } catch {
            setCopied(false);
        }
    };

    return (
        <div className="relative inline-block">
            <button
                data-testid="contract-status"
                aria-expanded={open}
                onClick={() => setOpen((v) => !v)}
                className="inline-flex items-center gap-2.5 border border-white/10 bg-[#07111F]/70 px-4 py-2 font-mono text-[10px] uppercase tracking-[0.22em] text-mute transition-all duration-300 hover:border-[#1677FF]/50 hover:text-ink"
            >
                <span>CONTRACT</span>
                {ACTRA_CONTRACT_ADDRESS ? (
                    <span className="text-[#31D8FF]" title={ACTRA_CONTRACT_ADDRESS}>
                        {CONTRACT_SHORT}
                    </span>
                ) : (
                    <span className="text-ink">COMING SOON</span>
                )}
            </button>
            <AnimatePresence>
                {open && (
                    <motion.div
                        data-testid="contract-status-message"
                        initial={{ opacity: 0, y: 6 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 6 }}
                        transition={{ duration: 0.25 }}
                        className="absolute left-0 top-[calc(100%+10px)] z-50 w-72 max-w-[calc(100vw-48px)] border border-white/10 bg-[#07111F] p-4 text-left shadow-[0_16px_48px_rgba(0,0,0,0.6)]"
                    >
                        <p className="font-mono text-[10px] font-semibold uppercase tracking-[0.24em] text-[#31D8FF]">
                            {ACTRA_CONTRACT_ADDRESS ? "$ACTRA CONTRACT — ARC MAINNET" : "CONTRACT COMING SOON"}
                        </p>
                        {ACTRA_CONTRACT_ADDRESS && (
                            <div className="mt-3 flex items-start justify-between gap-2">
                                <span data-testid="contract-full-address" className="break-all font-mono text-[10px] leading-relaxed text-ink">
                                    {ACTRA_CONTRACT_ADDRESS}
                                </span>
                                <button
                                    data-testid="contract-copy"
                                    onClick={copy}
                                    aria-label="Copy contract address"
                                    className="shrink-0 border border-white/10 p-2 text-mute transition-colors hover:text-ink"
                                >
                                    {copied ? <Check size={11} className="text-[#31D8FF]" /> : <Copy size={11} />}
                                </button>
                            </div>
                        )}
                        <p className="mt-2 text-xs leading-relaxed text-mute">{CONTRACT_MESSAGE}</p>
                        {EXPLORER_ADDRESS_URL && (
                            <a
                                href={EXPLORER_ADDRESS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="contract-explorer-link"
                                className="mt-3 inline-flex items-center gap-2 font-mono text-[10px] font-semibold uppercase tracking-[0.2em] text-[#8CB8FF] transition-colors hover:text-[#31D8FF]"
                            >
                                VIEW ON ARC EXPLORER <ArrowUpRight size={11} />
                            </a>
                        )}
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};

export default ContractStatus;
